var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useEffect, useState } from "react";
import { isFunction } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { setGlobalLoaders, setPageError } from "./store/AppState/actions";
import fb from "./firebase";
import { getDatabase, ref, child, onValue, onDisconnect } from "firebase/database";
import { getAllUtilityData, updateUtilitiesStatus } from "./store/Utilities/actions";
import { Alert, usePrevious } from "@brushfire/ui";
import QueueView from "./QueueView";
import MaintenanceView from "./MaintenanceView";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { WidgetContext } from "./components/Widget";
import { uuidv4 } from "@firebase/util";
import { fetchToken } from "./data/api";
import { getCustomerAccount } from "./store/Account/actions";
export var BF_QUEUE_ID = "bf-queue-id";
var useTypedSelector = useSelector;
var EntryQueue = function (_a) {
    var _b, _c;
    var children = _a.children, isWidget = _a.isWidget;
    var clientKey = window.location.pathname.split("/")[1];
    var _d = __read(useState(clientKey === "loading" ? true : false), 2), accessAllowed = _d[0], setAccessAllowed = _d[1];
    var _e = __read(useState(false), 2), utilitiesHaveLoaded = _e[0], setUtilitiesHaveLoaded = _e[1];
    var _f = __read(useState(false), 2), showMessages = _f[0], setShowMessages = _f[1];
    var _g = __read(useState(), 2), settings = _g[0], setSettings = _g[1];
    var _h = __read(useState(), 2), me = _h[0], setMe = _h[1];
    var _j = __read(React.useState(false), 2), playAudio = _j[0], setPlayAudio = _j[1];
    var _k = __read(useState(), 2), uid = _k[0], setUid = _k[1];
    var dispatch = useDispatch();
    var db = getDatabase(fb);
    //We're not consuming this value, but we need the hook to retrigger the render
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var location = useLocation();
    var eventNumber = [6, 7].includes((_b = window.location.pathname.split("/")[3]) === null || _b === void 0 ? void 0 : _b.length)
        ? window.location.pathname.split("/")[3]
        : undefined;
    var _l = useContext(WidgetContext), widgetId = _l.widgetId, setShowGlobalLoader = _l.setShowGlobalLoader;
    var isLoading = useTypedSelector(function (store) { return store.utilities.utilitiesStatus; }).isLoading;
    var timezones = useTypedSelector(function (store) { return store.utilities; }).timezones;
    var globalLoaders = useTypedSelector(function (store) { return store.app; }).globalLoaders;
    var showLoader = Object.values(globalLoaders).some(function (l) { return l === true; });
    useEffect(function () {
        setShowGlobalLoader(showLoader);
    }, [showLoader]);
    useEffect(function () {
        // Generate uuid instead of signing into firebase anonymously
        var localUUID = localStorage.getItem(BF_QUEUE_ID);
        if (localUUID) {
            setUid(localUUID);
        }
        else {
            var newUid = uuidv4();
            localStorage.setItem(BF_QUEUE_ID, newUid);
            setUid(newUid);
        }
    }, []);
    var previousAllow = usePrevious(me === null || me === void 0 ? void 0 : me.allow);
    var previousConnected = usePrevious(me === null || me === void 0 ? void 0 : me.connected);
    var params = new URLSearchParams(document.location.search);
    var oldUid = params.get("u");
    var bypass = params.get("bypass");
    var createPresence = function (payload, initial) {
        if (initial === void 0) { initial = false; }
        var widgetSourceClient = axios.create({
            baseURL: process.env.REACT_APP_BF_ENV === "staging" || process.env.REACT_APP_BF_ENV === "future"
                ? "https://apistaging-st3i2yb5oq-uc.a.run.app"
                : "https://apigen2-st3i2yb5oq-uc.a.run.app",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        widgetSourceClient
            .post("/attendees", payload)
            .then(function (_a) {
            var data = _a.data;
            if (data.success === true) {
                if (initial) {
                    console.log("Connection Established");
                }
            }
            else {
                console.error("Something went wrong while creating your session");
                dispatch(setPageError({
                    status: 500,
                    error: "Unable to connect to Brushfire",
                }));
            }
        })
            .finally(function () {
            dispatch(setGlobalLoaders({ entryQueue: false }));
        });
    };
    useEffect(function () {
        if (clientKey && clientKey !== "loading") {
            setAccessAllowed(false);
        }
    }, [clientKey]);
    useEffect(function () {
        if (isLoading && !utilitiesHaveLoaded) {
            setUtilitiesHaveLoaded(true);
        }
    }, [isLoading]);
    useEffect(function () {
        if (clientKey !== "loading") {
            if (!(me === null || me === void 0 ? void 0 : me.connected)) {
                dispatch(setGlobalLoaders({ entryQueue: true }));
            }
            var userRef_1 = ref(db, "/attendees/".concat(clientKey, "/").concat(uid));
            if (uid) {
                //This is a ref unique for each user so we can reliablly tell if they are connected
                //Even if the connection times out, the snapshot listener attempts to reconnect,
                //so people are only disconnected for avery short time
                var connectedRef = ref(db, ".info/connected");
                onValue(connectedRef, function (snapshot) {
                    if (snapshot.val() === true) {
                        onDisconnect(child(userRef_1, "connected"))
                            .set(false)
                            .then(function () {
                            // The promise returned from .onDisconnect().set() will
                            // resolve as soon as the server acknowledges the onDisconnect()
                            // request, NOT once we've actually disconnected:
                            // https://firebase.google.com/docs/reference/js/firebase.database.OnDisconnect
                            var _a, _b;
                            // We can now safely set ourselves as 'online' knowing that the
                            // server will mark us as offline once we lose connection.
                            createPresence({
                                uid: uid,
                                clientKey: clientKey,
                                path: window.location.pathname,
                                ua: window.navigator.userAgent,
                                bypassCode: bypass !== null && bypass !== void 0 ? bypass : undefined,
                                handoffId: oldUid !== null && oldUid !== void 0 ? oldUid : undefined,
                                forceQueue: false,
                                v: (_b = (_a = document.getElementById("brushfire")) === null || _a === void 0 ? void 0 : _a.getAttribute("src")) !== null && _b !== void 0 ? _b : "",
                                wid: widgetId !== null && widgetId !== void 0 ? widgetId : "x",
                            }, true);
                        })
                            .catch(function (reason) {
                            setPageError({
                                status: 500,
                                error: "onDisconnect was unable to be established",
                                message: reason.toString(),
                            });
                        })
                            .finally(function () {
                            var queryParams = new URLSearchParams(window.location.search);
                            if (queryParams.has("u")) {
                                var location_1 = window.location;
                                queryParams.delete("u");
                                location_1.search = queryParams.toString();
                                window.history.replaceState(null, "", location_1.href);
                            }
                        });
                    }
                });
            }
        }
    }, [uid, clientKey]);
    useEffect(function () {
        var settingsRef = ref(db, "/settings");
        if (clientKey !== "loading") {
            return onValue(settingsRef, function (snapshot) {
                setSettings(snapshot.val());
            });
        }
    }, [clientKey]);
    useEffect(function () {
        if (playAudio) {
            var audioInterval_1 = setInterval(function () {
                var audio = new Audio("https://brushfirecontent.blob.core.windows.net/0000/Media/queue-chime.mp3");
                audio.volume = 0;
                audio.muted = true;
                audio.play().catch(function () {
                    //swallow
                });
            }, 3000);
            return function () {
                clearInterval(audioInterval_1);
            };
        }
    }, [playAudio]);
    useEffect(function () {
        var _a, _b;
        if ((me === null || me === void 0 ? void 0 : me.connected) === false) {
            if (uid && previousConnected === true) {
                //If we get disconnected, while still connected, reconnect
                createPresence({
                    uid: uid,
                    clientKey: clientKey,
                    path: window.location.pathname,
                    ua: window.navigator.userAgent,
                    bypassCode: bypass !== null && bypass !== void 0 ? bypass : undefined,
                    handoffId: oldUid !== null && oldUid !== void 0 ? oldUid : undefined,
                    forceQueue: false,
                    v: (_b = (_a = document.getElementById("brushfire")) === null || _a === void 0 ? void 0 : _a.getAttribute("src")) !== null && _b !== void 0 ? _b : "",
                    wid: widgetId !== null && widgetId !== void 0 ? widgetId : "x",
                });
            }
        }
        else if ((me === null || me === void 0 ? void 0 : me.connected) === true) {
            setTimeout(function () {
                dispatch(setGlobalLoaders({ entryQueue: false }));
            }, 250);
        }
    }, [me === null || me === void 0 ? void 0 : me.connected, uid, previousConnected]);
    useEffect(function () {
        if (uid && !accessAllowed && clientKey !== "loading") {
            //Create subscription to allow property to determine if the user may go through
            //const userRef = ref(db, `/attendees/${clientKey}/${auth.currentUser.uid}`);
            var userRef = ref(db, "/public-attendees/".concat(clientKey, "/").concat(uid));
            return onValue(userRef, function (snapshot) {
                var user = snapshot.val();
                if ((user === null || user === void 0 ? void 0 : user.allow) === false) {
                    var audio = new Audio("https://brushfirecontent.blob.core.windows.net/0000/Media/queue-chime.mp3");
                    audio.volume = 0;
                    audio.muted = true;
                    audio.play().catch(function () {
                        //swallow
                    });
                }
                if ((user === null || user === void 0 ? void 0 : user.allow) !== accessAllowed && (user === null || user === void 0 ? void 0 : user.allow) !== undefined) {
                    fetchToken().then(function () {
                        setAccessAllowed(user === null || user === void 0 ? void 0 : user.allow);
                    });
                    dispatch(getCustomerAccount());
                }
                if ((user === null || user === void 0 ? void 0 : user.allow) === false) {
                    setShowMessages(true);
                }
                setMe(user);
            });
        }
    }, [uid, clientKey, accessAllowed]);
    useEffect(function () {
        if (accessAllowed && clientKey !== "loading") {
            if (!utilitiesHaveLoaded) {
                dispatch(getAllUtilityData());
            }
            else if (isLoading && (timezones === null || timezones === void 0 ? void 0 : timezones.length) > 0) {
                dispatch(updateUtilitiesStatus({ isLoading: false }));
            }
        }
    }, [accessAllowed]);
    useEffect(function () {
        if (previousAllow === false && (me === null || me === void 0 ? void 0 : me.allow) === true && playAudio) {
            var audio = new Audio("https://brushfirecontent.blob.core.windows.net/0000/Media/queue-chime.mp3");
            audio.play().catch(function () {
                //swallow
            });
        }
    }, [me === null || me === void 0 ? void 0 : me.allow]);
    if (settings === null || settings === void 0 ? void 0 : settings.maintenance.on) {
        return (_jsx("div", __assign({ className: "page-body ta-left m-top-medium" }, { children: _jsx(MaintenanceView, { settings: settings, isWidget: isWidget, eventNumber: eventNumber }) })));
    }
    return (_jsxs(_Fragment, { children: [((_c = settings === null || settings === void 0 ? void 0 : settings.clients[clientKey]) === null || _c === void 0 ? void 0 : _c.message) && (_jsx("div", __assign({ className: "page-body ta-left m-top-medium" }, { children: _jsx(Alert, __assign({ purpose: "primary" }, { children: settings === null || settings === void 0 ? void 0 : settings.clients[clientKey].message })) }))), !accessAllowed && !!settings && showMessages && (_jsx("div", __assign({ className: "page-body ta-left m-top-medium" }, { children: settings.maintenance.on ? (_jsxs(_Fragment, { children: [_jsx("h1", { children: settings.maintenance.heading }), _jsx("p", { children: settings.maintenance.body })] })) : (_jsx(QueueView, { clientKey: clientKey, settings: settings, me: me, eventNumber: eventNumber, playAudio: playAudio, setPlayAudio: setPlayAudio })) }))), isFunction(children) ? children(accessAllowed) : children] }));
};
export default EntryQueue;
